import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Login from './pages/Login';
import FreelancerDashboard from './pages/FreelancerDashboard';
import ClientDashboard from './pages/ClientDashboard';
import CategoryPage from './pages/CategoryPage';
import JoinFreelancer from './pages/JoinFreelancer';
import Contact from './pages/Contact';
import About from './pages/About';
import Services from './pages/Services';
import DynamicPage from './pages/DynamicPage';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isDashboardPage = location.pathname.startsWith('/admin') || 
                          location.pathname.startsWith('/freelancer') || 
                          location.pathname.startsWith('/client');

  return (
    <div className="App">
      {!isDashboardPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/category/:categoryName" element={<CategoryPage />} />
        <Route path="/join-freelancer" element={<JoinFreelancer />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/freelancer/*" element={<FreelancerDashboard />} />
        <Route path="/client/*" element={<ClientDashboard />} />
        <Route path="/:slug" element={<DynamicPage />} />
      </Routes>
      {!isDashboardPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
